// extracted by mini-css-extract-plugin
export default {"wrapper":"vz-z","viewport":"wz-z","container":"xz-z","slide":"yz-z"};